// extracted by mini-css-extract-plugin
export var Img = "Img-module--Img--6Hyul";
export var aniSpin = "Img-module--ani-spin--Be22e";
export var element = "Img-module--element--KV9eH";
export var loaded = "Img-module--loaded--4lXMe";
export var placeholder = "Img-module--placeholder--EFvcK";